import Vue from "vue"

Vue.filter("yearformat", value => {
    if (!value) return ''
    if (value == 0) return ''
    var d = new Date(value * 1000);
    return d.getFullYear()>0?d.getFullYear():'';
})

Vue.filter("datestringformat", (value, format) => {
    format = format || 0;
    if (!value) return ''
    var d = new Date(value);
    if (format == 0)
        return `${d.getDate()}.${d.getMonth()+1}.${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}`;
    else
        return d.getFullYear();
})

Vue.filter("dateformat", (value, format) => {
    format = format || 0;
    if (!value) return ''
    var d = new Date(value * 1000);
    if (format == 0)
        return `${d.getDate()}.${d.getMonth()+1}.${d.getFullYear()}`;
    else
        return d.getFullYear();
})

Vue.filter("splitlanguage", (value, language) => {
    return value.split("|")[language]
})
